module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAYCAYAAABTPxXiAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAzSURBVFhH7c8BDQAwEAOh+Tfd2SCfwwFvB5RQlFCUUJRQlFCUUJRQlFCUUJRQlFAcSGwfy8pOr+3DG6YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/logo3@2x.png
// module id = 3rZd
// module chunks = 126